let _ = require('../_.js');

var $ = jQuery;

// Time Manger helps represent time in local timezone for the auction.
// Usage:  let time = new TimeManager() - creates a new object, assumes current time is the passed time string.  Returns values related to current time.
// time.new("Y-m-d H:i:s.v") - creates a new object, representing the time of the passed string.  Calculations will be done against the timestamp provided by the parent object.
// time.seconds_since() - seconds since the provided timestamp is returned.
// time.seconds_until() - seconds until the provided timestamp is returned.
// time.human_until() - shows the duration until the timestamp as a human readable string like 3d 2h 21m 3s.  Pass 'true' to return a duration for timestamp in the past.
// time.diff("Y-m-d H:i:s.v") - returns seconds difference from object's timestamp and passed in timestamp.
// time.human() - returns human readable version of the time.

_.TimeManager = class TimeManager {

    static _init() {
        // console.log("Hello.");
    }

    async _test() {
        // Just some tests to make sure this is working properly.
        console.log("Hi.");

        console.log(this);
        console.log("Seconds since:", this.seconds_since());
        console.log("Seconds until:", this.seconds_until());
        console.log("Seconds since init:", this._seconds_since_init());
        console.log("Current:", this.current());
        console.log("Human:", this.human());
        console.log("Sleep 3");

        await _.sleep(3000);

        console.log("Seconds since:", this.seconds_since());
        console.log("Seconds until:", this.seconds_until());
        console.log("Current:", this.current());
        console.log("Human:", this.human());

        let test_time_1 = "2023-07-24 02:00:00";
        let test_time_2 = "2023-07-24 03:00:00";

        console.log("Diff 2 am:", this.diff(test_time_1));

        console.log("Creating new object");
        let newtime = this.new(test_time_1);

        console.log("Seconds until 2 am:", newtime.seconds_until());
        console.log("Diff 3 am:", newtime.diff(test_time_2));

        console.log("Human 2 am:", newtime.human());
        console.log("2 am since:", newtime.seconds_since());
        console.log("2 am until:", newtime.seconds_until());
        console.log("2 am until human:", newtime.human_until());

    }

    constructor(current_ymd_date, current_js_date = null, offset_date = null) {
        if (current_js_date === null) {
            current_js_date = new Date();
        }

        this._current_js_date = current_js_date;

        this._current_tz = null;

        if (current_ymd_date) {
            let cyd_parts = current_ymd_date.split(" ");

            if (cyd_parts.length == 3) {
                // Includes a timezone.
                this._current_tz = cyd_parts[2];
                current_ymd_date = cyd_parts[0] + " " + cyd_parts[1];
            } else {
            }

            this._current_ymd_date = current_ymd_date;
        } else {
            this._current_ymd_date = null;
        }

        this._offset_date = null;

        if (offset_date) {
            let od_parts = offset_date.split(" ");

            if (od_parts.length == 3) {
                // Includes a timezone.
                this._current_tz = od_parts[2];
                offset_date = od_parts[0] + " " + od_parts[1];
            }

            this._offset_date = offset_date;
        }
    }

    // Returns a unix timestamp of the date
    unix() {
        let date;
        if (this._offset_date) {
            date = new Date(this._offset_date.replace(' ', 'T'));
        } else {
            date = new Date(this._current_ymd_date.replace(' ', 'T'));
            date.setTime(date.getTime() + (this._seconds_since_init() * 1000));
        }
        return Math.floor(date.getTime() / 1000);
    }

    // Returns current time as Y-m-d H:i:s.v unless offset date provided
    current() {
        if (this._offset_date) {
            return this._offset_date;
        } else {
            let date = new Date(this._current_ymd_date.replace(' ', 'T'));
            date.setTime(date.getTime() + (this._seconds_since_init() * 1000));
            return date.toLocaleString('sv-SE').replace('T', ' ').substring(0, 19);
        }
    }

    // Returns seconds until offset_date from ymd_date
    _offset() {
        if (this._offset_date == null) {
            return 0;
        }
        let initial = new Date(this._current_ymd_date.replace(' ', 'T'));
        let target = new Date(this._offset_date.replace(' ', 'T'));
        return (target.getTime() - initial.getTime()) / 1000;
    }

    _seconds_since_init() {
        return (new Date().getTime() - this._current_js_date.getTime()) / 1000;
    }

    seconds_since() {
        return (new Date().getTime() - this._current_js_date.getTime()) / 1000 - this._offset();
    }

    seconds_until() {
        return (this._current_js_date.getTime() - new Date().getTime()) / 1000 + this._offset();
    }

    human_until(show_past = false) {
        return TimeManager.duration_to_str(this.seconds_until(), show_past);
    }

    human_since() {
        return TimeManager.duration_to_str(this.seconds_since(), false);
    }

    new(offset_date) {
        return new TimeManager(this._current_ymd_date, this._current_js_date, offset_date);
    }

    add(seconds) {
        let uts = this.unix();
        uts += seconds;

        let formatTimestamp = function (timestamp) {
            const date = new Date(timestamp * 1000);

            const year = date.getFullYear();
            // getMonth() returns 0-11; adding 1 to get 1-12
            const month = ('0' + (date.getMonth() + 1)).slice(-2);
            const day = ('0' + date.getDate()).slice(-2);
            const hours = ('0' + date.getHours()).slice(-2);
            const minutes = ('0' + date.getMinutes()).slice(-2);
            const seconds = ('0' + date.getSeconds()).slice(-2);

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        }

        return this.new(formatTimestamp(uts));
    }

    subtract(seconds) {
        return this.add(0 - seconds);
    }

    diff(mixed_date) {
        if (mixed_date._offset_date) {
            mixed_date = _offset_date;
        }

        let ymd_date = mixed_date;

        let initial = new Date(this.current().replace(' ', 'T'));
        let target = new Date(ymd_date.replace(' ', 'T'));
        return (initial.getTime() - target.getTime()) / 1000;
    }

    human() {
        let timestamp = this.current();

        let date = new Date(timestamp);
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let ampm = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;

        let strTime = hours + ':' + minutes + ' ' + ampm;
        let month = date.getMonth() + 1;
        // month = month < 10 ? '0' + month : month;
        let day = date.getDate();
        day = day < 10 ? '0' + day : day;
        let year = (date.getFullYear() != new Date().getFullYear()) ? ("/" + date.getFullYear()) : "";

        return month + "/" + day + year + " " + strTime + (this._current_tz ? " " + this._current_tz : "");
    }

    human_date() {
        let timestamp = this.current();
        let date = new Date(timestamp);
        const day = date.getDate();
        let suffix = 'th';
        if (day === 1 || day === 21 || day === 31) suffix = 'st';
        if (day === 2 || day === 22) suffix = 'nd';
        if (day === 3 || day === 23) suffix = 'rd';

        const month = date.toLocaleDateString('en-US', { month: 'long' });
        const year = date.getFullYear();

        return `${month} ${day}${suffix}, ${year}`;
    }

    human_w_seconds(subseconds = 0) {
        let timestamp = this.current();

        let date = new Date(timestamp);
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();
        let ampm = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        seconds = seconds < 10 ? '0' + seconds : seconds;
        let subsecondStr = timestamp.toString().includes('.') ? timestamp.toString().split('.')[1].slice(0, subseconds) : '';
        subsecondStr += '0'.repeat(subseconds - subsecondStr.length); // Padding zeros if needed

        let strTime = hours + ':' + minutes + ':' + seconds + '.' + subsecondStr + ' ' + ampm;
        let month = date.getMonth() + 1;
        month = month < 10 ? '0' + month : month;

        let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();

        let yearPart = (date.getFullYear() != new Date().getFullYear()) ? ("/" + date.getFullYear()) : "";
        return month + "/" + day + yearPart + " " + strTime + timezone_string;
    }


    static duration_to_str(diff_seconds, show_past = false) {

        let is_past = false;

        if (diff_seconds < 0) {
            is_past = true;
            diff_seconds = diff_seconds * -1;
        }

        if (is_past && !show_past) {
            return "";
        }

        const days = Math.floor(diff_seconds / (60 * 60 * 24));
        diff_seconds -= days * 60 * 60 * 24;
        const hours = Math.floor(diff_seconds / (60 * 60));
        diff_seconds -= hours * 60 * 60;
        const minutes = Math.floor(diff_seconds / 60);
        diff_seconds -= minutes * 60;
        const seconds = Math.floor(diff_seconds);

        // If the duration is more than one hour, omit the seconds
        let result = "";
        if (days > 0) result += `${days}d `;
        if (days > 0 || hours > 0) result += `${hours}h `;
        if (days > 0 || hours > 0 || minutes > 0) result += `${minutes}min`;
        if (days === 0 && hours === 0) result += ` ${seconds}s`;

        if (is_past) result += ' ago';

        return result.trim();
    }

    // Displays a live countdown in the target element.
    countdown($element, prefix = '', suffix = '', show_zero = false) {
        let time = this;

        // Clear any existing interval
        if ($element.data('countdownInterval')) {
            clearInterval($element.data('countdownInterval'));
        }

        // Set up a new interval
        const intervalId = setInterval(() => {
            const duration = time.human_until();

            if (duration === "") {
                if (show_zero) {
                    $element.text("0:00");
                } else {
                    $element.hide();
                    clearInterval($element.data('countdownInterval'));
                }
            } else {
                if ($element.is(":visible")) {
                    $element.text(`${prefix}${duration}${suffix}`);
                }
            }

            // Update the element's text
        }, 1000);

        // Save the interval ID on the element
        $element.data('countdownInterval', intervalId);
    }

    // Displays a live count of seconds / minutes / whatever since 
    countup($element, prefix = '', suffix = '') {
        let time = this;

        // Clear any existing interval
        if ($element.data('countdownInterval')) {
            clearInterval($element.data('countdownInterval'));
        }

        // Set up a new interval
        let intervalId = setInterval(() => {
            let duration = time.human_since();

            // Display the elapsed time
            if ($element.is(":visible") && duration) {
                $element.text(`${prefix}${duration}${suffix}`);
            } else {
                $element.text("---");
            }

            // Update the element's text
        }, 1000);

        // Save the interval ID on the element
        $element.data('countdownInterval', intervalId);
    }

    static countcancel($element) {
        if ($element.data('countdownInterval')) {
            clearInterval($element.data('countdownInterval'));
            $element.text('');
        }
    }

}
